export type ButtonIndicatorType = 'none' | 'newWindowInternal' | 'externalLink';

export const buttonIndicatorMap: Record<
  ButtonIndicatorType,
  'newWindowInternal' | 'externalLink' | 'newTabInternal' | undefined
> = {
  newWindowInternal: 'newWindowInternal',
  externalLink: 'externalLink',
  none: undefined,
} as const;
